import { arrayOf, oneOfType, node, string } from 'prop-types';

import styles from './Banner.scss';

export const Banner = ({
  children = null,
  imgSrc = 'https://via.placeholder.com/1920x400',
  className = '',
  ...props
}) => (
  <section className={[styles.BannerImg, className].join(' ').trim()} {...props}>
    <img src={imgSrc} alt="banner" className={styles.ImgFluid} />
    {children}
  </section>
);

Banner.propTypes = {
  imgSrc: string,
  className: string,
  children: oneOfType([node, arrayOf(node)]),
};
